module.exports = __webpack_public_path__ + "media/assets/icons/thunder-cloud-9d2f54e721342118060d4d4cace85d30.svg";